import PazienteAllegatiList from "../allegati/components/PazienteAllegatiList.vue";
import PazienteAllegatiEdit from "../allegati/components/PazienteAllegatiEdit.vue";
export default {
    PazienteAllegatiList,
    PazienteAllegatiEdit,
};
